import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import BeneficiaryForm from './BeneficiaryForm';
import SimpleList from './SimpleList';
import SimpleExpansionPanel from './SimpleExpansionPanel';
import BeneficiaryFindAccount from './BeneficiaryFindAccount';
import { Button, Grid, CircularProgress } from '@material-ui/core';



const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: `100px`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `90%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `90%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `90%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `90%`,
        },
    },
    logotwo: {
        [theme.breakpoints.up('xs')]: {
            width: `70px`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `80%`,
        },
    },
    icon: {
        [theme.breakpoints.up('xs')]: {
            minWidth: '56px'
        },
        [theme.breakpoints.up('sm')]: {
            width: `40%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `24%`,
        },
    },
    listItems: {
        [theme.breakpoints.up('xs')]: {
            color: 'white',
            fontSize: '70%'
        },
        [theme.breakpoints.up('sm')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('md')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('lg')]: {
            color: 'white',
            fontSize: '100%'
        },
        [theme.breakpoints.up('xl')]: {
            color: 'white',
            fontSize: '100%'
        },
    },
    imgLogo: { height: '40%' },
    styleaccordion: {
        borderLeft: '3px solid #014587',
        // backgroundColor : "#5A5759",
        color: "black",
        minWidth: "100%",
        width: `100%`,
    },
    colorbutton: {
        backgroundColor: "rgb(101,174,46);",
        color: "white",
        "&:hover": {
            backgroundColor: "rgb(101,174,46);",
            color: "white",
        }
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    }
}));


const BeneficiaryFormDialog = ({ onCloseBeneficiaryForm, openBeneficiaryForm, pristine, onAcceptClick, findAccountUser,
    beneficiaryFormData, beneficiaryFormDataExternal, clearForm, setEntity, setType, setDocument, setInstitution, accounts, AddBeneficiaryCore, getSelectAccount, entities,
    institutions, handleChangeOpenAccordionInternal, handleChangeOpenAccordionExternal, openAccordionInternal, openAccordionExternal, typeBeneficiaries, invalid, loadingSearch }) => {
    const [title, setTitle] = useState('Seleccione Cuenta del beneficiario');
    const [expanded, setExpanded] = useState(true);
    const [selected, setSelected] = useState(false);
    const [typeFind, setTypeFind] = useState('cedule')
    //const [loading, setLoading] = useState(true)
    const [showDetails, setShowDetails] = useState(false)
    const classes = useStyles();
    //console.log('ENT: ', entities)
    //console.log('loadingSearch default', loadingSearch)
    //console.log('accounts', accounts)
    //console.log('accounts.length', accounts.length)
    const handleSubmit = (values) => {
        // console.log('VALUES: ', values)
        onAcceptClick(values)
    }

    const handleConvertMask = (numberBeneficiary) => {

        if (numberBeneficiary.length > 7) {

            let resultConvert = ""

            const [a, b, c, d, ...dataConvert] = numberBeneficiary

            const inicioFin = dataConvert.length - 3

            const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

            for (let y = 0; y < inicioFin; y++) {
                resultConvert = resultConvert.concat("X")
            }

            resultConvert = a + b + c + d + resultConvert + ultimos

            return resultConvert

        } else {

            return numberBeneficiary

        }

    }

    const handleSelectAccount = (value) => {
        // console.log(value);
        const { PRODUCTBANKID, CLIENTNAME } = value
        setTitle(`${handleConvertMask(PRODUCTBANKID)} - ${CLIENTNAME}`)
        getSelectAccount(value)
        setExpanded(false)
        setSelected(true)
    }

    const findAccountExist = (data) => {

        //setLoading(true)
        /*  this.setState({ loading: true }) */
        //loading=true
        verificateFindAccountExist(data)

    }

    const renderAccountDetails = () => {
        // console.log('accounts.length', accounts)
        // console.log('loadingSearch', loadingSearch)
        if (accounts.length > 0) {
            return <SimpleExpansionPanel
                name={title || 'seleccion'}
                expanded={expanded}
                //loading={loading}
                handleChange={() => expanded ? setExpanded(false) : setExpanded(true)} >
                <SimpleList
                    dataList={accounts}
                    name={nameInternal}
                    selectAccount={handleSelectAccount}
                />
            </SimpleExpansionPanel>
        } else {
            if (loadingSearch) {
                return <CircularProgress />
            }
            return ''
        }
        /* if (accounts.length === 0) {
            return <CircularProgress />
        } else {
            if (accounts.length > 0) {
                return <SimpleExpansionPanel
                    name={title || 'seleccion'}
                    expanded={expanded}
                    loading={loading}
                    handleChange={() => expanded ? setExpanded(false) : setExpanded(true)} >
                    <SimpleList
                        dataList={accounts}
                        name={nameInternal}
                        selectAccount={handleSelectAccount}
                    />
                </SimpleExpansionPanel>
            }
        } */
    }

    //functions
    const verificateFindAccountExist = async (data) => {
        //setLoading(true)
        try {
            // console.log("loadingSearch verificateFindAccountExist", loadingSearch)
            const { code } = data
            setTitle('Seleccione Cuenta del beneficiario')
            await findAccountUser(code, typeFind)
            setSelected(false)
            //setLoading(false)
            setShowDetails(true)
        } catch (error) {
            //setLoading(false)
        }

    }
    const { name: nameInternal } = beneficiaryFormData
    const { cedule, name, beneficiary, number, entity, email, document, institution } = beneficiaryFormDataExternal

    let beneficiario = 'INTERNO'
    !beneficiary && (beneficiario = 'INTERNO')
    return (
        <Dialog
            // fullScreen
            open={openBeneficiaryForm}
            onClose={onCloseBeneficiaryForm}
            fullWidth={true}
            maxWidth='sm'
            // disableBackdropClick
            // disableEscapeKeyDown
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{'Nuevo Beneficiario'}</DialogTitle>
            {/* <AppBar >
                <Toolbar style={{ position: 'relative', backgroundColor: "#2E2757" }}>
                    <IconButton edge="start" color="inherit" onClick={onCloseBeneficiaryForm} aria-label="close">
                        <CloseIcon style={{ color: "#FFFFFF" }} />
                    </IconButton>
                    <Typography variant="h6" style={{ flex: 1, color: "#FFFFFF" }}>
                        {'Nuevo Beneficiario'}
                    </Typography>
                </Toolbar>
            </AppBar> */}
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                </DialogContentText>
                <br />

                {
                    (typeBeneficiaries === "INTERNO") ?


                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12} sm={12}>
                                <br />
                                <BeneficiaryFindAccount
                                    classes={classes}
                                    selectype={(val) => setTypeFind(val.value)}
                                    onSubmit={findAccountExist}
                                    onCloseBeneficiaryForm={onCloseBeneficiaryForm}
                                    document={document}
                                    setDocument={setDocument}
                                />
                                {/* {console.log('loading', loading)}
                                        {console.log('accounts.length', accounts.length)} */}
                                {
                                    /* (accounts.length === 0) ?
                                        <CircularProgress />
                                        : */
                                    (showDetails) && renderAccountDetails()
                                    /* (accounts.length > 0) &&
                                    <SimpleExpansionPanel
                                        name={title || 'seleccion'}
                                        expanded={expanded}
                                        loading={loading}
                                        handleChange={() => expanded ? setExpanded(false) : setExpanded(true)} >
                                        <SimpleList
                                            dataList={accounts}
                                            name={nameInternal}
                                            selectAccount={handleSelectAccount}
                                        />
                                    </SimpleExpansionPanel> */
                                }
                                <br></br>
                                <br></br>
                                <Grid container spacing={2} /* justifyContent="center" alignItems="center" */>
                                    <Grid item xs={6} sm={6} md={2} lg={2} xl={2} /* container justifyContent="center" */>
                                        <Button
                                            variant="contained"
                                            className={classes.buttonStandard}
                                            /* style={{
                                                fontSize: '1rem',
                                                color: '#ffffff',
                                                borderRadius: '4px',
                                                '&.Mui-disabled': {
                                                    backgroundColor: "#a7a8a8",
                                                },
                                                '&:hover': {
                                                    backgroundColor: "#706D85",
                                                },
                                                backgroundColor: "#2E2757",
                                                //fontFamily: 'MyriadPro-Bold'
                                            }} */
                                            //color={'#a7a8a8'}
                                            disabled={!selected}
                                            onClick={() => AddBeneficiaryCore()}
                                        >
                                            Aceptar
                                        </Button>
                                    </Grid>
                                    {/* <Grid item xs={6} sm={6} md={2} lg={2} xl={2} container justifyContent="center">
                                                <Button
                                                    style={{
                                                        fontSize: '1rem',
                                                        color: '#FFFFFF',
                                                        backgroundColor: "#2E2757",
                                                        borderRadius: '8px',
                                                        //fontFamily: 'MyriadPro-Bold'
                                                    }}
                                                    variant="contained"
                                                    // className = {classes.colorbutton}
                                                    onClick={() => onCloseBeneficiaryForm()}>
                                                    Cancelar
                                                </Button>
                                            </Grid> */}
                                </Grid>
                            </Grid>
                        </Grid>

                        :

                        <BeneficiaryForm
                            cedule={cedule}
                            email={email}
                            name={name}
                            number={number}
                            entity={entity}
                            document={document}
                            institution={institution}
                            institutions={institutions}
                            setEntity={setEntity}
                            setType={setType}
                            setDocument={setDocument}
                            setInstitution={setInstitution}
                            beneficiary={beneficiario}
                            clearForm={clearForm}
                            entities={entities}
                            classes={classes}
                            onSubmit={handleSubmit}
                            cancelPrompt={onCloseBeneficiaryForm}
                        //addBeneficiaryCore={AddBeneficiaryCore}
                        // findAccount = { findAccountExist }
                        />

                }

                <br />

            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
};

BeneficiaryFormDialog.propTypes = {
    onCloseBeneficiaryForm: PropTypes.func.isRequired,
    findAccountUser: PropTypes.func.isRequired,
    openBeneficiaryForm: PropTypes.bool.isRequired,
    onAcceptClick: PropTypes.func.isRequired,
}

export default BeneficiaryFormDialog;